<template>
  <div class="vip-age__svg">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="128"
      height="235"
      viewBox="0 0 128 235"
    >
      <g transform="translate(-346 -1863)">
        <path
          d="M52.749,425.148V355.866l60-34.641,60,34.641v69.282l-60,34.641Z"
          transform="translate(297.251 1545.775)"
          fill="none"
          stroke="rgba(216,216,216,0.56)"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="8"
        />
        <path
          d="M52.749,425.148V355.866l60-34.641,60,34.641v69.282l-60,34.641Z"
          transform="translate(297.251 1545.775) "
          fill="none"
          :stroke-dasharray="`${age.percentage * 420} 420`"
          stroke-dashoffset="-140"
          :stroke="color"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="8"
        />
        <text
          transform="translate(353 1946)"
          fill="#010101"
          font-size="28"
          font-family="Arial-BoldMT, Arial"
          font-weight="700"
        >
          <tspan x="55" y="0" text-anchor="middle">
            {{ age.num }}
          </tspan>
        </text>
        <text
          transform="translate(375 2048)"
          fill="#010101"
          font-size="14"
          font-family="MicrosoftYaHei, Microsoft YaHei"
          letter-spacing="0.05em"
        >
          <tspan x="0" y="0">{{ age.range }}</tspan>
        </text>
        <rect
          width="60"
          height="30"
          rx="15"
          transform="translate(376 2068)"
          :fill="color"
        />
        <text
          transform="translate(396 2088)"
          fill="#fff"
          font-size="14"
          font-family="Arial-BoldMT, Arial"
          font-weight="700"
        >
          <tspan x="13" y="0" text-anchor="middle">{{ age.percentage }}%</tspan>
        </text>
      </g>
    </svg>
  </div>
</template>
<script>
export default {
  name: 'VipAgeSvg',
  props: {
    age: {
      type: Object,
      default: () => {
        return {}
      }
    },
    index: {
      type: Number
    }
  },
  data() {
    this.colors = ['#eb6580', '#ce7cb1', '#8b72b1', '#dcc4a1', '#f29969']
    return {}
  },
  computed: {
    /**
     * 颜色
     * @returns {*}
     */
    color() {
      return this.colors[this.index]
    }
  }
}
</script>
